type Method = 'reset' | 'page' | 'identify' | 'alias' | 'track';

export const createAnalyticsTracker = (debug: boolean) => (
  method: Method,
  // tslint:disable-next-line:no-any
  ...contextArgs: any[]
) => {
  if (debug) {
    // tslint:disable-next-line:no-console
    console.log(`analyticsTracker.${method}:`, ...contextArgs);
  }
  if (global.analytics) {
    global.analytics[method](...contextArgs);
  }
};
